import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import styles from '../Toolbar.styles';
import './FlagColorToolbar.css';
import {setSelectedToken, toggleDestructionTool} from '../../../redux/actions';
import {selectDestructionToolActive, selectSelectedToken} from '../../../redux/reducers/privateStateReducer/selectors';
import {ToolbarButton} from '../ToolbarButton';
import {COLORS_CONFIG, PLAYER_COLORS} from '../../../configs/colors';
import {FLAG_PREFIX} from '../../../constants/tokens';
import {SPECTATOR_COLOR} from '../../../constants/players';

// Цвета флагов: все игровые цвета, кроме служебных (нейтральный, наблюдатель)
const FLAG_COLORS = Object.values(PLAYER_COLORS).filter(
  (color) => color !== PLAYER_COLORS.NEUTRAL && color !== SPECTATOR_COLOR
);

const COLOR_LABELS = {
  [PLAYER_COLORS.BLUE]: 'Синий',
  [PLAYER_COLORS.INDIGO]: 'Индиго',
  [PLAYER_COLORS.SKY_BLUE]: 'Голубой',
  [PLAYER_COLORS.CELADON]: 'Селадон',
  [PLAYER_COLORS.LIGHT_GREEN]: 'Салатовый',
  [PLAYER_COLORS.DARK_GREEN]: 'Темно-зеленый',
  [PLAYER_COLORS.VIOLET]: 'Фиолетовый',
  [PLAYER_COLORS.PURPLE]: 'Пурпурный',
  [PLAYER_COLORS.PINK]: 'Розовый',
  [PLAYER_COLORS.GREY]: 'Серый',
  [PLAYER_COLORS.LIGHT_GREY]: 'Светло-серый',
  [PLAYER_COLORS.RED]: 'Красный',
  [PLAYER_COLORS.YELLOW]: 'Желтый',
  [PLAYER_COLORS.ORANGE]: 'Оранжевый',
  [PLAYER_COLORS.BONE]: 'Костяной',
  [PLAYER_COLORS.LIGHT_BROWN]: 'Светло-коричневый',
  [PLAYER_COLORS.BROWN]: 'Коричневый',
};

/**
 * Панель флага для редактора поля: один инструмент "флаг" + палитра цветов
 * из PLAYER_COLORS. Выбранный цвет определяет размещаемый токен flag_<цвет>.
 */
const FlagColorToolbar = () => {
  const dispatch = useDispatch();
  const selectedToken = useSelector(selectSelectedToken);
  const destructionToolActive = useSelector(selectDestructionToolActive);
  const [flagColor, setFlagColor] = useState(PLAYER_COLORS.BLUE);

  const flagTokenId = `${FLAG_PREFIX}${flagColor}`;
  const colorLabel = COLOR_LABELS[flagColor] || flagColor;

  const selectFlagToken = (tokenId) => {
    // Если инструмент разрушения активен, выключаем его при выборе токена
    if (destructionToolActive) {
      dispatch(toggleDestructionTool());
    }
    dispatch(setSelectedToken(tokenId));
  };

  const handleColorSelect = (color) => {
    setFlagColor(color);
    // Флаг уже выбран инструментом — сразу перевыбираем токен нового цвета
    if (selectedToken && selectedToken.startsWith(FLAG_PREFIX)) {
      selectFlagToken(`${FLAG_PREFIX}${color}`);
    }
  };

  return (
    <div style={styles.container}>
      <div className="flag-color-toolbar">
        <ToolbarButton
          tokenId={flagTokenId}
          selected={selectedToken === flagTokenId}
          label={`Флаг игрока (${colorLabel})`}
          onClick={() => selectFlagToken(flagTokenId)}
        />

        <div className="flag-color-palette">
          {FLAG_COLORS.map((color) => (
            <button
              key={color}
              type="button"
              className={`flag-color-swatch ${flagColor === color ? 'flag-color-swatch-active' : ''}`}
              style={{backgroundColor: COLORS_CONFIG[color]}}
              title={COLOR_LABELS[color] || color}
              onClick={() => handleColorSelect(color)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FlagColorToolbar;
